import * as yup from "yup";

const EducationSchema = yup.object().shape({
  title: yup.string().required("Title is required"),
  started: yup.date().required("Start date is required"),
  completed: yup.date().required("Completion date is required"),
});

export default EducationSchema;
